import React from "react";
import AppButton from "../../../components/common/appButton/AppButton";
const CustomerReview = ({
  data,
  onBack,
  onSubmit,
  isLoading
}) => {
  return (
    <div>

      <h1
        className="
          text-[29px]
          font-normal
          text-[#183240]
        "
      >
        Review your{" "}
        details
      </h1>

      <p className="mt-2 text-[11px] text-[#9aa1a7]">
        Make sure everything looks correct before creating your account.
      </p>


      <div className="mt-6 space-y-3">

        <ReviewSection
          title="Personal Information"
        >
          <ReviewRow
            label="Name"
            value={`${data.first_name} ${data.last_name}`}
          />

          <ReviewRow
            label="Email"
            value={data.email}
          />

          <ReviewRow
            label="Phone"
            value={data.phone_number}
          />
        </ReviewSection>


        <ReviewSection
          title="Property Preferences"
        >
          {/* <ReviewRow
            label="Property Type"
            value={data.propertyType || "Not selected"}
          />

          <ReviewRow
            label="Bedrooms"
            value={data.bedrooms || "Not selected"}
          /> */}

          <ReviewRow
            label="Budget"
            value={data.budget || "Not selected"}
          />

          <ReviewRow
            label="Locations"
            value={
              data.preferredLocations ||
              "Not specified"
            }
          />

        </ReviewSection>

      </div>


      <div className="mt-5 flex gap-3">

        <AppButton
          variant="secondary"
          onClick={onBack}
        >
          ← Back
        </AppButton>

        <AppButton onClick={onSubmit} loading= {isLoading}> 
          Continue →
        </AppButton>

      </div>

    </div>
  );
};


const ReviewSection = ({
  title,
  children,
}) => (
  <div className="rounded-[10px] border border-[#e5e5e3] bg-white p-4">

    <h3 className="mb-3 text-[11px] font-bold text-[#183240]">
      {title}
    </h3>

    <div className="space-y-2">
      {children}
    </div>

  </div>
);


const ReviewRow = ({
  label,
  value,
}) => (
  <div className="flex justify-between gap-5 text-[10px]">

    <span className="text-[#9aa1a7]">
      {label}
    </span>

    <span className="text-right font-medium text-[#374b57]">
      {value || "-"}
    </span>

  </div>
);

export default CustomerReview;